import { Tag } from "components/designV2/tag/tag";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export interface TagLabelChipProps {
  tagText: string;
  label: string;
}

/** Compact row with tag and label text. */
export const TagLabelChip = ({
  tagText,
  label,
}: TagLabelChipProps): JSX.Element => {
  return (
    <Wrapper>
      <Tag text={tagText} />
      <Label>{label}</Label>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const Label = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;
